export const webAppConfigIsVisible = (val, webAppConfig) => {
  // console.log("WebappConfig", webAppConfig);
  // console.log(
  //   "filter Data Web app config",
  //   webAppConfig.filter((item) => item.ControlName === val)[0]?.isVisible,
  //   val
  // );
  return webAppConfig.filter((item) => item.ControlName === val)[0]?.isVisible;
};
